import { Store, StoreConfig } from '@datorama/akita';
import { UserInfo } from '@app/core/models';
import { Injectable } from '@angular/core';

const initialState: UserInfo = {} as UserInfo;

@Injectable({
	providedIn: 'root'
})
@StoreConfig({ name: 'userinfo' })
export class UserInfoStore extends Store<UserInfo> {
	constructor() {
		super(initialState);
	}
}
